import axios from "axios";

// const baseURL = process.env.VUE_APP_API_BASE_URL || window.location.origin;
// const baseURL = "https://havaianas-confi.mbsi.com.ph";
const baseURL = "https://staff.mbsi.com.ph";
// const baseURL = "https://localhost:5001";
// const baseURL = "https://evaair.mbsi.com.ph";
// const baseURL = "https://terrysa.mbsi.com.ph";
// const baseURL = "https://newfood.mbsi.com.ph";
// const baseURL = "https://ctgroup.mbsi.com.ph";
// const baseURL = "https://terryczarina.mbsi.com.ph";
// const baseURL = "https://dileonardo.mbsi.com.ph";
// const baseURL = "https://gogame.mbsi.com.ph";
// const baseURL = "https://hubvantage.mbsi.com.ph";
// const baseURL = "https://newfood.mbsi.com.ph";
// const baseURL = "https://dev1.mbsi.com.ph";
// const baseURL = "https://upcmngmt.mbsi.com.ph";


export default axios.create({
  baseURL,
  // You can add your headers here
});
